import { render, staticRenderFns } from "./FleetEditor.vue?vue&type=template&id=2059d031&scoped=true&"
import script from "./FleetEditor.vue?vue&type=script&lang=js&"
export * from "./FleetEditor.vue?vue&type=script&lang=js&"
import style0 from "./FleetEditor.vue?vue&type=style&index=0&id=2059d031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059d031",
  null
  
)

export default component.exports